import React, { FC } from 'react'
import { FlexRow } from 'components/Flex'
import { Checkbox } from 'components/Form'
import { parseOrderType } from 'lib/helper'

type Props = {
  checkedOrderTypes: string[]
  orderTypes: string[]
  handleCheckbox: (id: string) => void
}

const OrderTypeCheckboxes: FC<Props> = (props) => {
  const { checkedOrderTypes, orderTypes, handleCheckbox } = props
  return (
    <FlexRow justifyContent={'start'} itemNum={'two'}>
      {orderTypes.map((orderType) => (
        <Checkbox
          dataCy={orderType}
          key={orderType}
          fontSize={14}
          id={orderType}
          isChecked={checkedOrderTypes.some((checkedOrderType) => checkedOrderType === orderType)}
          label={parseOrderType(orderType)}
          handleCheckbox={handleCheckbox}
        />
      ))}
    </FlexRow>
  )
}

export default OrderTypeCheckboxes
